const configuration = {
  cookie: {
    PATH: '/',
    // DOMAIN: 'uid.ir',
    DOMAIN: 'u-id.net',
    MAX_AGE: '3600', //1hour
  },
  test: {
    SERVER_IP_ADDR: '...',
    OTHER_CONFIG_KEY: '...',
  },
};

export default configuration;
